<template>
  <v-container>
    <v-card>
      <v-card-title class="headline font-weight-regular blue-grey white--text">
        Consumption Log
      </v-card-title>
    </v-card>
    <v-card class="table-card pa-4">
      <h2>Last Grocery Shopping: {{ lastGroceryShoppingDayOfYear }}</h2>
      Today: {{ todayDayOfYear }} 
      <br><br>
      <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
      <div v-if="!loading">
        <div class="headers">
          <div class="cell">Name</div>
          <div class="cell">Inventory</div>
          <div class="cell">Consumed</div>
          <div class="cell">New</div>
        </div>
        <div v-for="item in items" :key="item.id">
          <div class="row">
            <!-- Item Name -->
            <div class="cell">{{ item.name }}</div>
            <!-- Item Inventory -->
            <div class="cell">{{ item.inventory }} {{ item.unit }}</div>
            <!-- Item Portion -->
            <div class="cell">
              {{ item.consumed }} {{ item.unit }}
            </div>
            <div class="cell" v-if="item.inventory - item.consumed > 0">
              {{ item.inventory - item.consumed }} {{ item.unit }}
            </div>
            <div class="cell" v-else>
              0 {{ item.unit }}
            </div>
          </div>
        </div>
        <br><br>
        <v-btn block color="secondary" dark @click="update">Update Inventory</v-btn>
      </div>
    </v-card>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import db from '@/firebase/firestore'
import moment from 'moment'
export default {
  name: 'Log',
  data() {
    return {
      day: 0,
      lastGroceryShoppingDayOfYear: 0,
      todayDayOfYear: 0,
      days: [],
      plan: [],
      meals: [],
      components: [],
      foods: [],
      items: [],
      loading: true,
      snack: false,
      snackColor: '',
      snackText: '',
    }
  },
  methods: {
    update() {
      // ---------- 
      this.items.forEach( item => {
        // console.log("item", item)
        if( item.inventory - item.consumed < 0 ) {
          item.inventory = 0
        } else {
          item.inventory -= item.consumed
        }
      })
      // console.log('items',this.items)
      // ----------
      let index = 0
      this.items.forEach( item => {
        let ref = db.collection('food')
        ref.doc(item.id).set(item).then(() => {
          index++
          if( index == this.items.length ) {
            // ----------
            this.snack = true
            this.snackText = "Inventory Updated"
            // ----------
            this.$router.push('/fuel/shopping')
          }
        })
      })
    }
  },
  created() {
    // ---------- Calculate Day ----------
    this.day = moment(moment().diff('10/1/2018')).format('DDD') % 14
    if( this.day == 0 ) this.day = 14
    // ---------- Get Last Shopping ----------
    let shoppingRef = db.collection('groceries').get().then( (snapshot) => {
      let biggest = 0
      snapshot.forEach( doc => {
        let groceries = doc.data()
        if( groceries.moment > biggest ) {
            this.lastGroceryShoppingDayOfYear = 
            moment.unix(parseInt(groceries.moment)).dayOfYear()
            // console.log('LAST DAY', groceries.day)
        }
      })
      // 
      this.todayDayOfYear = moment().dayOfYear()
      // console.log('last', this.lastGroceryShoppingDayOfYear)
      // console.log('today', this.todayDayOfYear)
      let consumptionDays = []
      for( let d=this.lastGroceryShoppingDayOfYear; d<=this.todayDayOfYear; d++ ) {
        let dDay = parseInt(moment(moment().dayOfYear(d).diff('10/1/2018')).format('DDD')) % 14
        // console.log( d, dDay )
        if( dDay == 0 ) dDay = 14
        this.days.push(dDay)
      }
      // console.log(this.days)
      // ---------- Load Plan
      this.days.forEach( day => {
        let planRef = db.collection('plan').doc(day.toString()).get().then( snapshot => {
          // console.log('ss', snapshot)
          // console.log('data',snapshot.data())
          let plan = snapshot.data()
          this.plan.push( plan )
          if( this.plan.length == this.days.length ) {
            // ---------- Load Meals
            let index = 0
            this.plan.forEach( day => {
              index++
              if( this.meals.length == 0 ) {
                // This is the first day, only include evening
                if( day.aaron.eveningStack && day.aaron.eveningStack.id ) this.meals.push({
                  id: day.aaron.eveningStack.id,
                  portion: day.aaron.eveningStack.portion
                })
                if( day.aaron.dinner && day.aaron.dinner.id ) this.meals.push({
                  id: day.aaron.dinner.id,
                  portion: day.aaron.dinner.portion
                })
                if( day.aaron.eveningSnack && day.aaron.eveningSnack.id ) this.meals.push({
                  id: day.aaron.eveningSnack.id,
                  portion: day.aaron.eveningSnack.portion
                })
                if( day.ronan.eveningStack && day.ronan.eveningStack.id ) this.meals.push({
                  id: day.ronan.eveningStack.id,
                  portion: day.ronan.eveningStack.portion
                })
                if( day.ronan.dinner && day.ronan.dinner.id ) this.meals.push({
                  id: day.ronan.dinner.id,
                  portion: day.ronan.dinner.portion
                })
                if( day.ronan.eveningSnack && day.ronan.eveningSnack.id ) this.meals.push({
                  id: day.ronan.eveningSnack.id,
                  portion: day.ronan.eveningSnack.portion
                })
              } else if( index == this.plan.length ) {
                // This is the last day
                if( day.aaron.morningStack && day.aaron.morningStack.id ) this.meals.push({
                  id: day.aaron.morningStack.id,
                  portion: day.aaron.morningStack.portion
                })
                if( day.aaron.breakfast && day.aaron.breakfast.id ) this.meals.push({
                  id: day.aaron.breakfast.id,
                  portion: day.aaron.breakfast.portion
                })
                if( day.aaron.morningSnack && day.aaron.morningSnack.id ) this.meals.push({
                  id: day.aaron.morningSnack.id,
                  portion: day.aaron.morningSnack.portion
                })
                if( day.aaron.afternoonStack && day.aaron.afternoonStack.id ) this.meals.push({
                  id: day.aaron.afternoonStack.id,
                  portion: day.aaron.afternoonStack.portion
                })
                if( day.aaron.lunch && day.aaron.lunch.id ) this.meals.push({
                  id: day.aaron.lunch.id,
                  portion: day.aaron.lunch.portion
                })
                if( day.aaron.afternoonSnack && day.aaron.afternoonSnack.id ) this.meals.push({
                  id: day.aaron.afternoonSnack.id,
                  portion: day.aaron.afternoonSnack.portion
                })
                //
                if( day.ronan.morningStack && day.ronan.morningStack.id ) this.meals.push({
                  id: day.ronan.morningStack.id,
                  portion: day.ronan.morningStack.portion
                })
                if( day.ronan.breakfast && day.ronan.breakfast.id ) this.meals.push({
                  id: day.ronan.breakfast.id,
                  portion: day.ronan.breakfast.portion
                })
                if( day.ronan.morningSnack && day.ronan.morningSnack.id ) this.meals.push({
                  id: day.ronan.morningSnack.id,
                  portion: day.ronan.morningSnack.portion
                })
                if( day.ronan.afternoonStack && day.ronan.afternoonStack.id ) this.meals.push({
                  id: day.ronan.afternoonStack.id,
                  portion: day.ronan.afternoonStack.portion
                })
                if( day.ronan.lunch && day.ronan.lunch.id ) this.meals.push({
                  id: day.ronan.lunch.id,
                  portion: day.ronan.lunch.portion
                })
                if( day.ronan.afternoonSnack && day.ronan.afternoonSnack.id ) this.meals.push({
                  id: day.ronan.afternoonSnack.id,
                  portion: day.ronan.afternoonSnack.portion
                })
              } else {
                // This is a regular day
                if( day.aaron.morningStack && day.aaron.morningStack.id ) this.meals.push({
                  id: day.aaron.morningStack.id,
                  portion: day.aaron.morningStack.portion
                })
                if( day.aaron.breakfast && day.aaron.breakfast.id ) this.meals.push({
                  id: day.aaron.breakfast.id,
                  portion: day.aaron.breakfast.portion
                })
                if( day.aaron.morningSnack && day.aaron.morningSnack.id ) this.meals.push({
                  id: day.aaron.morningSnack.id,
                  portion: day.aaron.morningSnack.portion
                })
                if( day.aaron.afternoonStack && day.aaron.afternoonStack.id ) this.meals.push({
                  id: day.aaron.afternoonStack.id,
                  portion: day.aaron.afternoonStack.portion
                })
                if( day.aaron.lunch && day.aaron.lunch.id ) this.meals.push({
                  id: day.aaron.lunch.id,
                  portion: day.aaron.lunch.portion
                })
                if( day.aaron.afternoonSnack && day.aaron.afternoonSnack.id ) this.meals.push({
                  id: day.aaron.afternoonSnack.id,
                  portion: day.aaron.afternoonSnack.portion
                })
                if( day.aaron.eveningStack && day.aaron.eveningStack.id ) this.meals.push({
                  id: day.aaron.eveningStack.id,
                  portion: day.aaron.eveningStack.portion
                })
                if( day.aaron.dinner && day.aaron.dinner.id ) this.meals.push({
                  id: day.aaron.dinner.id,
                  portion: day.aaron.dinner.portion
                })
                if( day.aaron.eveningSnack && day.aaron.eveningSnack.id ) this.meals.push({
                  id: day.aaron.eveningSnack.id,
                  portion: day.aaron.eveningSnack.portion
                })
                //
                if( day.ronan.morningStack && day.ronan.morningStack.id ) this.meals.push({
                  id: day.ronan.morningStack.id,
                  portion: day.ronan.morningStack.portion
                })
                if( day.ronan.breakfast && day.ronan.breakfast.id ) this.meals.push({
                  id: day.ronan.breakfast.id,
                  portion: day.ronan.breakfast.portion
                })
                if( day.ronan.morningSnack && day.ronan.morningSnack.id ) this.meals.push({
                  id: day.ronan.morningSnack.id,
                  portion: day.ronan.morningSnack.portion
                })
                if( day.ronan.afternoonStack && day.ronan.afternoonStack.id ) this.meals.push({
                  id: day.ronan.afternoonStack.id,
                  portion: day.ronan.afternoonStack.portion
                })
                if( day.ronan.lunch && day.ronan.lunch.id ) this.meals.push({
                  id: day.ronan.lunch.id,
                  portion: day.ronan.lunch.portion
                })
                if( day.ronan.afternoonSnack && day.ronan.afternoonSnack.id ) this.meals.push({
                  id: day.ronan.afternoonSnack.id,
                  portion: day.ronan.afternoonSnack.portion
                })
                if( day.ronan.eveningStack && day.ronan.eveningStack.id ) this.meals.push({
                  id: day.ronan.eveningStack.id,
                  portion: day.ronan.eveningStack.portion
                })
                if( day.ronan.dinner && day.ronan.dinner.id ) this.meals.push({
                  id: day.ronan.dinner.id,
                  portion: day.ronan.dinner.portion
                })
                if( day.ronan.eveningSnack && day.ronan.eveningSnack.id ) this.meals.push({
                  id: day.ronan.eveningSnack.id,
                  portion: day.ronan.eveningSnack.portion
                })
              }
            })
            // console.log('meals',this.meals)
            // console.log('loaded')
            // ---------- Get components
            let mealIndex = 0
            this.meals.forEach( meal => {
              let mealRef = db.collection('meals').doc(meal.id).get().then( (snapshot) => {
                mealIndex++
                let mealData = snapshot.data()
                mealData.components.forEach( component => {
                  let portion = parseFloat(meal.portion) * parseFloat(component.portion)
                  // console.log("portion", portion)
                  this.components.push({
                    id: component.id,
                    portion: portion
                  })
                })
                // console.log(mealIndex, this.meals.length, meal)
                if( mealIndex == this.meals.length ) {
                  // console.log('Loaded')
                  // console.log('Components', this.components)
                  let componentIndex = 0
                  this.components.forEach( component => {
                    // console.log("component", component)           
                    let foodRef = db.collection('food').doc(component.id).get().then( (snapshot) => {
                      componentIndex++
                      let food = snapshot.data()
                      // console.log('food',food)
                      if( typeof this.foods[food.id] === 'undefined') {
                        // console.log('new food element')
                        food.portion = component.portion
                        this.foods[food.id] = food
                      } else {
                        // console.log('existing food element')
                        this.foods[food.id].portion += component.portion
                      }
                      if( componentIndex == this.components.length ) {
                        // console.log('Loaded.')
                        // console.log(this.components.length, this.foods.length, this.foods)
                        // ---------- Convert to standard array
                        for( var index in this.foods ) {
                          // console.log('index',index, this.foods[index])
                          this.foods[index].consumed = ( Math.round(this.foods[index].portion * this.foods[index].serving) * 100 ) / 100 
                          this.items.push(this.foods[index])
                        }
                        // console.log(this.items)
                        this.loading = false
                      }
                    })
                  })
                }
              })
            })
          }
        })
      })
    })
  }
}
</script>

<style scoped>
  .row {
    display: flex;
    flex-direction: row;
  }
  .row .cell {
    flex: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    border-left: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
  }
  .row .cell:first-child {
    flex: 4;
    justify-content: left;
  }
  .row .cell:last-child {
    border-right: 1px solid #f5f5f5;
  }
  .headers {
    display: flex;
    flex-direction: row;
  }
  .headers .cell {
    flex: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: #f5f5f5;
    font-size: 10px;
    font-weight: bold;
  }
  .headers .cell:first-child {
    flex: 4;
    justify-content: left;
  }
  .cell.total:first-child {
    justify-content: flex-end;
    font-weight: bold;
    padding: 10px 20px;
  }
</style>
